import type { ReactNode } from 'react'
import { FamilyCard } from '../Common/FamilyCard'
import './familyStatePage.css'

export interface FamilyStatePageProps {
  tone?: 'neutral' | 'danger'
  title?: ReactNode
  body: ReactNode
  actions?: ReactNode
  ariaLabel?: string
  testId?: string
}

export const FamilyStatePage = ({
  tone = 'neutral',
  title,
  body,
  actions,
  ariaLabel,
  testId,
}: FamilyStatePageProps) => {
  return (
    <main
      className={[
        'familyStatePage',
        tone === 'danger' ? 'familyStatePage--danger' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      <FamilyCard className="familyStatePage__card">
        {title && <h1 className="familyStatePage__title">{title}</h1>}
        <div className="familyStatePage__body">
          {typeof body === 'string' ? <p className="familyStatePage__text">{body}</p> : body}
        </div>
        {actions && <div className="familyStatePage__actions">{actions}</div>}
      </FamilyCard>
    </main>
  )
}
